import { render, staticRenderFns } from "./Colour.vue?vue&type=template&id=fb5fedd4"
import script from "./Colour.vue?vue&type=script&lang=js"
export * from "./Colour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports